import { CommonModule } from '@angular/common';
import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  ContentChild,
  Input,
  OnDestroy,
  Optional,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatColumnDef, MatTable, MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-table-column',
  template: `
    <ng-container matColumnDef>
      <th mat-header-cell *matHeaderCellDef>
        {{ labelT | translate }}
      </th>

      <td mat-cell *matCellDef="let row; let i = index">
        <ng-container
          [ngTemplateOutlet]="cellTemplate || defaultTemplate"
          [ngTemplateOutletContext]="{ $implicit: row, dataIndex: i }"
        ></ng-container>
        <ng-template #defaultTemplate>
          {{ getData(row) }}
        </ng-template>
      </td>
    </ng-container>
  `,
  styles: [``],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, MatTableModule, TranslateModule],
  standalone: true,
})
export class TableColumnComponent<T> implements AfterContentInit, OnDestroy {
  @Input() labelT: string;
  @Input({ required: true }) name!: string;
  @Input() dataAccessor!: (data: T, name: string) => string;

  @ViewChild(MatColumnDef, { static: true }) columnDef!: MatColumnDef;
  @ContentChild(TemplateRef) cellTemplate?: TemplateRef<any>;

  constructor(
    @Optional() public table: MatTable<any>,
    private cd: ChangeDetectorRef,
  ) {}

  ngAfterContentInit(): void {
    if (this.table) {
      this.columnDef.name = this.name;
      this.table.addColumnDef(this.columnDef);
      this.cd.detectChanges();
    } else {
      console.warn('table not found');
    }
  }

  ngOnDestroy() {
    if (this.table) {
      this.table.removeColumnDef(this.columnDef);
    }
  }

  getData(data: T): any {
    return this.dataAccessor ? this.dataAccessor(data, this.name) : (data as any)[this.name];
  }
}
